import type { DropdownInstance } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useResponsive } from 'store'
import { DialogHeader, HocElDialog, HocElPopover, useDialog } from 'ui-components'
import { ContractMiniQuotes } from './ContractMiniQuotes.tsx'

// 交易对 h5 / pc 融合组件
export default defineComponent({
  name: 'ContractMiniQuotesTrigger',
  props: {
    coinName: {
      type: String,
      default: '',
    },
  },
  setup(props, { slots }) {
    const { openDialog, closeDialog, dialogVisible } = useDialog()
    const dropdownRef = ref<DropdownInstance>()
    const openPopover = ref(false)

    const { t } = useI18n()

    const onShowDialog = () => {
      if (dialogVisible.value) {
        closeDialog()
      } else {
        openDialog()
      }
    }

    const onTableRowClick = () => {
      openPopover.value = false
    }

    const responsive = useResponsive()

    watch(
      () => openPopover.value,
      (val) => {
        if (val) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = 'unset'
        }
      },
    )

    onBeforeUnmount(() => {
      document.body.style.overflow = 'unset'
    })

    return () => (
      <div class="font-medium text-lg my-4 mt-4 mb-3">
        {!responsive.isMobile ? (
          <HocElPopover
            ref={dropdownRef}
            popper-class="trade-popper"
            placement="bottom-start"
            trigger="focus"
            v-model:visible={openPopover.value}
            width="auto"
            hideAfter={0}
            onHide={() => {
              openPopover.value = false
            }}
            appendTo="body"
            popperStyle={{
              left: 0,
              bottom: 0,
              padding: '16px 0 0',
              width: '580px',
            }}
          >
            {{
              reference: () => <div onClick={() => (openPopover.value = !openPopover.value)}>{slots.default?.()}</div>,
              default: () => {
                if (openPopover.value) {
                  return (
                    <div onClick={(e) => e.stopPropagation()} style={{ height: '100%' }}>
                      <ContractMiniQuotes onRowClick={() => onTableRowClick()} />
                    </div>
                  )
                }
                return null
              },
            }}
          </HocElPopover>
        ) : (
          <div class="flex items-center coin-name" onClick={onShowDialog}>
            {slots.default?.()}
          </div>
        )}

        <HocElDialog v-model={dialogVisible.value} offsetTop={64} placement={'bottom'} footer={null} showClose={false}>
          {{
            header: () => <DialogHeader onClose={closeDialog}>{t('合约')}</DialogHeader>,
            default: () => (dialogVisible.value ? <ContractMiniQuotes onRowClick={closeDialog} /> : null),
          }}
        </HocElDialog>
      </div>
    )
  },
})
